import { DataModel } from "common/models/utility-models/base-model";

export class branchCategoryListModel extends DataModel
{
  override id: "";
  branchCatName: "";
}